<script setup>
import { ref } from "vue";

const form = ref({
  from_name: "",
  to_name: "",
  message: "",
});
const sendEmail = async () => {
  const message = `Ola, meu nome é ${form.value.from_name}, quero te contratar, entre em contato com esse e-mail ${form.value.to_name}<br/>${form.value.message}`;
  window.open(
    `https://api.whatsapp.com/send?phone=5599991357424&text=${message}`
  );
};
</script>

<template>
  <v-col cols="12" sm="8">
    <h1 class="mt-8">Envie sua mensagem</h1>
    <v-divider></v-divider>
    <span class="text-caption">Me envie uma mensagem para me contratar.</span>
    <v-row class="mt-10">
      <v-col cols="12" sm="6">
        <v-text-field
          label="Nome"
          v-model="form.from_name"
          persistent-hint
          variant="outlined"
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="6">
        <v-text-field
          label="E-mail"
          persistent-hint
          v-model="form.to_name"
          variant="outlined"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-textarea
      label="Mensagem"
      persistent-hint
      variant="outlined"
      v-model="form.message"
    ></v-textarea>
    <v-btn @click="sendEmail" color="red" class="mt-2">Enviar agora</v-btn>
  </v-col>
</template>